module.exports = __FOREMAN_VENDOR__SPICE_PROJECT_SPICE_HTML_5__;